var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePencilSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7586 5.73165L14.268 2.24024C14.1519 2.12414 14.0141 2.03204 13.8624 1.9692C13.7107 1.90637 13.5482 1.87402 13.384 1.87402C13.2198 1.87402 13.0572 1.90637 12.9056 1.9692C12.7539 2.03204 12.6161 2.12414 12.5 2.24024L2.86641 11.8746C2.74983 11.9903 2.65741 12.1279 2.59451 12.2796C2.5316 12.4313 2.49948 12.594 2.50001 12.7582V16.2496C2.50001 16.5811 2.6317 16.8991 2.86612 17.1335C3.10054 17.3679 3.41849 17.4996 3.75001 17.4996H7.24141C7.40563 17.5001 7.5683 17.468 7.71999 17.4051C7.87168 17.3422 8.00935 17.2498 8.12501 17.1332L17.7586 7.49962C17.8747 7.38354 17.9668 7.24573 18.0296 7.09405C18.0925 6.94238 18.1248 6.77981 18.1248 6.61563C18.1248 6.45146 18.0925 6.28889 18.0296 6.13721C17.9668 5.98554 17.8747 5.84772 17.7586 5.73165ZM7.24141 16.2496H3.75001V12.7582L10.625 5.88321L14.1164 9.37462L7.24141 16.2496ZM15 8.49024L11.5086 4.99962L13.3836 3.12462L16.875 6.61524L15 8.49024Z",
    fill: "#005596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePencilSimple);
export default __webpack_public_path__ + "static/media/BluePencilSimple.42401765d147259abf34e77283bde7e2.svg";
export { ForwardRef as ReactComponent };